// extracted by mini-css-extract-plugin
export default {"page-header":"PageHeader_page-header__auMAd"};